export class DocumentId {

  public static valid(val: string): boolean {
    return (!!val && val.split(':').length > 0);
  }

  public static parse(val: string): { schema: string; pk: number} {
    const items = val.split(':');
    return {
      schema: items[1],
      pk: parseInt((items.pop() as string), 10),
    };
  }

}
